import { Directive, HostListener, input, output } from '@angular/core';

@Directive({
  selector: '[appLongPress]'
})
export class LongPressDirective {
  duration = input(1000);
  longPress = output<void>();
  private pressTimeout: any;

  @HostListener('mousedown')
  @HostListener('touchstart')
  onPressStart() {
    this.pressTimeout = setTimeout(() => {
      this.longPress.emit();
    }, this.duration()); // customize duration
  }

  @HostListener('mouseup')
  @HostListener('mouseleave')
  @HostListener('touchend')
  onPressEnd() {
    clearTimeout(this.pressTimeout);
  }
}
